export function arrayStartsWith<T>(array: Array<T>, arrayToCompare: Array<T>): boolean {
  return (
    array.length >= arrayToCompare.length &&
    array.slice(0, arrayToCompare.length).every((value, index) => value === arrayToCompare[index])
  );
}
